import { render, staticRenderFns } from "./GetCustomerInvoices.vue?vue&type=template&id=302170fb&scoped=true&"
import script from "./GetCustomerInvoices.vue?vue&type=script&lang=js&"
export * from "./GetCustomerInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302170fb",
  null
  
)

export default component.exports